import React from "react";
import "./CommonField.css";

function CommonInput({
  type = "text",
  value,
  onChange,
  placeholder = "",
  className = "",
  inputClassName = "",
  icon = null,
  rightAction = null,
  disabled = false,
  ...props
}) {
  const wrapperClassName = ["common-field", disabled ? "is-disabled" : "", className]
    .filter(Boolean)
    .join(" ");
  const controlClassName = ["common-field-control", inputClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      {icon ? <span className="common-field-icon">{icon}</span> : null}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={controlClassName}
        disabled={disabled}
        {...props}
      />
      {rightAction ? rightAction : null}
    </div>
  );
}

export default CommonInput;
